import { z } from 'zod';

const AlgoliaBrandImageSchema = z.object({
  cta_text: z.string().nullish(),
  cta_url: z.string().nullish(),
  description: z.string().nullish(),
  image_url: z.string().nullish(),
  position: z.number().nullish(),
});

const AlgoliaBrandVideoSchema = z.object({
  overlay_image_url: z.string().nullish(),
  overlay_text: z.string().nullish(),
  video_url: z.string().nullish(),
});

const AlgoliaBrandSchema = z.object({
  color_hex: z.string().nullish(),
  custom_image_url: z.string().nullish(),
  custom_images: z.array(AlgoliaBrandImageSchema).nullish(),
  custom_video: AlgoliaBrandVideoSchema.nullish(),
  description: z.string().nullish(),
  has_active_brand_special: z.boolean().optional(),
  id: z.number(),
  logo_url: z.string().nullish(),
  name: z.string(),
  objectID: z.string(),
  productCount: z.number().nullish(),
  rank: z.number().nullish(),
  uuid: z.string(),
});

export type AlgoliaBrand = z.infer<typeof AlgoliaBrandSchema>;

export const AlgoliaBrandsSchema = z.array(AlgoliaBrandSchema);
